import React from 'react';
import { Vn, Us } from 'react-flags-select';
import classNames from 'classnames';
// Redux
import { useDispatch, useSelector } from 'react-redux';

import styled from 'styled-components';

import { Menu } from '@headlessui/react';
import { locale } from 'devextreme/localization';
import { RootState } from 'app/store';
import { LanguageSelectType, updateLanguage } from '@slice/user.slice';
// Style component
const FlagSelect = styled.div.attrs({
  className: `
  flex 
  items-center 
  rounded-md
  py-1
  px-3
  cursor-pointer 
  h-[30px]
 `
})<{ active?: boolean; theme?: any }>`
  background-color: ${({ active, theme }) => (active ? theme.active!.background : '#fff')};
  color: ${({ active, theme }) => (active ? theme.active!.text : '#000')};
  &:hover {
    background-color: ${({ active, theme }) => (active ? theme.active!.hover : '#d0d0d0')};
    transform: scale(1.05);
  }
  &:active {
    background-color: ${({ theme }) => theme.active!.background};
    color: ${({ theme }) => theme.active!.text};
  }
`;

interface IDropdownTranslate {
  isActive?: string | undefined;
}

const DropdownTranslate = (props: IDropdownTranslate) => {
  const dispatch = useDispatch();
  // Selector
  const language = useSelector((state: RootState) => state.user.language);
  const selectedTheme = useSelector((state: RootState) => state.select.themeSelected);
  const handleUpdateLanguage = (value: LanguageSelectType) => {
    dispatch(updateLanguage(value));
    locale(value === LanguageSelectType.VIETNAM ? 'vi' : 'en');
  };

  return (
    <div
      className={classNames(
        props.isActive === 'translate' ? 'active_header_menu-parent' : '',
        'select-none block bg-white  rounded-md p-2 space-y-1 w-max border-[1px]'
      )}
    >
      <FlagSelect
        theme={selectedTheme}
        active={language === LanguageSelectType.VIETNAM ? true : false}
        onClick={() => handleUpdateLanguage(LanguageSelectType.VIETNAM)}
      >
        <Vn className="rounded-sm w-4"></Vn>
        <span className="ml-2 cursor-pointer">Tiếng Việt</span>
      </FlagSelect>

      <FlagSelect
        theme={selectedTheme}
        active={language === LanguageSelectType.ENGLISH ? true : false}
        onClick={() => handleUpdateLanguage(LanguageSelectType.ENGLISH)}
      >
        <Us className="rounded-sm w-4"></Us>
        <span className="ml-2 cursor-pointer">English</span>
      </FlagSelect>
    </div>
  );
};

export default function LanguageSetting() {
  const dispatch = useDispatch();

  const language = useSelector((state: RootState) => state.user.language);
  const activeButtonHeader = useSelector((state: RootState) => state.select.activeButtonHeader);
  // const handleActiveBtn = (keyClass: string | undefined) => {
  //   dispatch(updateActiveButtonHeader(keyClass));
  // };

  return (
    <div className="block">
      <Menu>
        <Menu.Button className="flex items-center">
          <div className="rounded-full w-10 h-10 text-justify cursor-pointer duration-75 flex items-center justify-center">
            {language === LanguageSelectType.ENGLISH ? (
              <Us className="rounded-sm w-6"></Us>
            ) : (
              <Vn className="rounded-sm w-6"></Vn>
            )}
          </div>
        </Menu.Button>
        <Menu.Items>
          <div className="fixed transform origin-left right-0 z-50 w-fit text-base list-none rounded-md shadow-md">
            <DropdownTranslate isActive={activeButtonHeader} />
          </div>
        </Menu.Items>
      </Menu>
    </div>
  );
}
